
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-6f254718\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./modalSalaries.scss")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./modalSalaries.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6f254718\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./modalSalaries.vue.html"),
  /* scopeId */
  "data-v-6f254718",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/modalComponents/modalSalaries/modalSalaries.vue.html
// module id = /Qxw
// module chunks = 2